import React, { Fragment } from 'react';
interface PageLayoutProps {
  title: string;
  /** Supporting subtitle shown below title */
  description?: string;
  /** Alias for description */
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  breadcrumbs?: Array<{
    label: string;
    href?: string;
  }>;
}
export function PageLayout({
  title,
  description,
  subtitle,
  actions,
  children,
  className = '',
  breadcrumbs
}: PageLayoutProps) {
  const displayDescription = description ?? subtitle;
  return <div className={`flex flex-col h-full min-h-0 ${className}`} data-id="element-8682" data-mp="3u56k58qqfxdr">
      {/* Header */}
      <div className="flex-shrink-0 px-4 py-3 sm:px-6 sm:py-5 border-b border-slate-200 bg-white/80 backdrop-blur-sm" data-id="element-8683" data-mp="3ffsd47amps1j">
        {breadcrumbs && breadcrumbs.length > 0 && <div className="flex items-center gap-1.5 mb-2" data-id="element-8684" data-mp="36dj1fe3mjsmk">
            {breadcrumbs.map((crumb, i) => <Fragment key={i} data-id="element-8685" data-mp="3afw41tn2raf4" data-mpi={i}>
                {i > 0 && <span className="text-slate-300 text-xs" data-id="element-8686" data-mp="3aeur1jmi0dur">/</span>}
                <span className="text-xs text-slate-400" data-id="element-8687" data-mp="1u2d3olj0112f">{crumb.label}</span>
              </Fragment>)}
          </div>}
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-8688" data-mp="1p6e5y7bs66pc">
          <div className="min-w-0 flex-1" data-id="element-8689" data-mp="240st8k2do29t">
            <h1 className="text-base sm:text-xl font-black text-slate-900 leading-tight" data-id="element-8690" data-mp="1z1y1gsmfn3dk">
              {title}
            </h1>
            {displayDescription && <p className="text-sm text-slate-500 mt-0.5 line-clamp-1 sm:line-clamp-none" data-id="element-8691" data-mp="1basiw5p3xwzk">
                {displayDescription}
              </p>}
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0" data-id="element-8692" data-mp="1l4j85ct26bgb">
              {actions}
            </div>}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-5" data-id="element-8693" data-mp="skufi2w98s29">
        {children}
      </div>
    </div>;
}